import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { Controller, useFormContext } from "react-hook-form";
import { PatternFormat } from "react-number-format";
import ValidationService from "../../Services/Shared/Validation.service";
import StringUtils from "../../../util/stringUtils";
import useUniqueId from "../Hooks/useUniqueId";
import ObjectService from "../../Services/Shared/Object.service";
import { Regex } from "../../../util/Regex";
/**
 * We do telephone input field validation differently in both forms and mobile because we have access to
 * a newer version of react-hook-form that allows for better interaction
 *
 * This implementation is temporary to work with the current react-hook-form version and should be
 * replaced when we update it
 */
const TelephoneField = ({ name, label, required, disabled, helpText, className, }) => {
    const makeId = useUniqueId()[1];
    const { errors } = useFormContext();
    const error = React.useMemo(() => ObjectService.getPropertyAtPath(errors, name), [errors, name]);
    return (_jsxs("div", { className: classNames("form-group", { required }, className), children: [label && _jsx("label", { htmlFor: makeId(name), children: label }), _jsx("div", { className: ValidationService.makeClassName(errors, name, "input-group mb-0"), children: _jsx(Controller, { as: _jsx(PatternFormat, { format: "(###) ###-####", allowEmptyFormatting: true, mask: "_", disabled: disabled, className: ValidationService.makeClassName(errors, name, "form-control"), required: true }), name: name, rules: {
                        validate: (v) => {
                            // Input is empty and not required
                            if (!v && !required) {
                                return true;
                            }
                            // Normalize phone number to get rid of mask / formatting
                            const normalizedPhone = StringUtils.normalizePhoneNumber(v);
                            // If phone number is required and normalized phone number is empty
                            if (normalizedPhone.length === 0 && required) {
                                return "Required";
                            }
                            // If a normalized phone number was provided
                            if (normalizedPhone.length !== 0) {
                                // Check for valid phone number length
                                if (normalizedPhone.length !== 10) {
                                    return "Please enter a telephone number with 10 digits.";
                                }
                                // Check for valid phone number format
                                if (!Regex.PHONE.test(v)) {
                                    return "Please enter a valid telephone number (e.g. (555) 555-5555).";
                                }
                            }
                            // Otherwise allow it
                            return true;
                        },
                        required: required ? `${label} is required` : false,
                    } }) }), error && _jsx("div", { className: "invalid-feedback", children: error.message }), helpText && _jsx("small", { className: "text-muted", children: helpText })] }));
};
export default TelephoneField;
